<template>
  <div>
    <Login v-if="!isOk" :type="2" :onSuccess="handleSuccess"></Login>
    <div v-if="isOk">
      <Empty v-if="isEmpty" image="error" description="获取兑换信息出错">
        <Button round type="danger" class="bottom-button" @click="handleSuccess">点击重试</Button>
      </Empty>
      <div v-else>
        <div class="tips">兑换查询结果</div>
        <div class="main">
          <div class="info">
            <img :src="planImg" alt="">
            <div class="status">
              <p>卡号：{{ cardId }}</p>
              <p>卡号状态：<Tag size="medium" :type="sharedStore.status === 1 ? 'warning' : 'success'">{{ sharedStore.status === 1 ? '已兑换' : '未兑换'}}</Tag></p>
            </div>
          </div>
          <div class="bill" v-if="sharedStore.status === 1">
            <div class="bill_info">
              <img :src="order.proPicUrl" alt="">
              <div class="bill_text">
                <div class="bold">名称：{{order.proName}}</div>
                <div>产品编号：{{order.proNo}}</div>
                <div>快递公司：{{ order.deliveryCom }}</div>
                <div>快递单号：{{ order.deliveryNum }}</div>
              </div>
            </div>
            <div class="people_info">
              <div class="line"></div>
              <Field
                  readonly
                  label="联系人"
                  :value="order.addresseeName"
              >
              </Field>
              <Field
                  readonly
                  label="联系电话"
                  :value="order.addresseeMobile"
              >
              </Field>
              <Field
                  readonly
                  label="备用电话"
                  :value="order.bakMobile || '无'"
              >
              </Field>
              <Field
                  readonly
                  label="地址"
                  :value="order.address"
              >
              </Field>
              <Field
                  readonly
                  type="textarea"
                  :autosize="{ minHeight: 60 }"
                  label="详细地址"
                  :value="order.detailAddress"
              >
              </Field>
              <Field
                  readonly
                  type="textarea"
                  :autosize="{ minHeight: 100 }"
                  label="留言"
                  :value="order.remark"
              >
              </Field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Tag, Divider, Card, Field, Empty, Button, Toast, Notify } from 'vant'
import Login from "../components/Login";
import store from "../store";
import config from "../config";
export default {
  name: 'Home',
  components: {
    Login,
    Tag,
    Divider,
    Card,
    Field,
    Empty,
    Button
  },
  data () {
    return {
      token: sessionStorage.getItem('token'),
      order: {},
      isOk: false,
      isEmpty: false,
      sharedStore: store.state,
      cardId: '',
      planImg: ''
    }
  },
  computed: {
    statusText () {
      switch (this.order.status) {
        case 0: return '无效订单'
        case 1: return '无效订单'
        case 0: return '无效订单'
      }
    }
  },
  methods: {
    handleSuccess () {
      const { token, cardId } = this.sharedStore
      this.isOk = true
      Toast.loading({
        message: '加载中',
        forbidClick: true
      })
      axios.get(`${config.publicPath}/exchange-api/api/order/cardAndPlan`, {
        headers:{
          "token": token
        }
      }).then(info => {
        if (info.data.code === 0) {
          this.cardId = info.data.data.cardDTO.account
          this.planImg = info.data.data.planDTO.planPicDTOS[0].url
          store.setItem('onlyPlanId', info.data.data.planDTO.id)
        }
        axios.get(
            `${config.publicPath}/exchange-api/api/order/page?cardId=${cardId}&page=1&limit=-1`,
            {
              headers:{
                "token": token
              }
            }
        ).then(res => {
          const { code, msg, data } = res.data
          if (code === 0) {
            Toast.clear()
            Notify({ type: 'success', message: '兑换查询成功', duration: 1000 });
            this.order = data.list[0]
            this.isEmpty = false
            this.token = token
          } else {
            this.isEmpty = true
            Toast.clear()
            Toast.fail(msg)
          }
        })
      })

    }
  },
  mounted() {
    if (this.sharedStore.token) {
      this.isOk = true
      this.handleSuccess()
    }
  }
}
</script>
<style scoped lang="less">
.tips {
  background-color: #07c160;
  color: white;
  font-size: 14px;
  padding: 8px 6px;
  font-weight: bold;
  margin-bottom: 20px;
}
.main {
  padding: 0 6px;

  .info {
    display: flex;
    align-items: center;
    box-shadow: 0 0 6px 1px rgba(204, 204, 204, 0.62);
    padding: 10px 0;


    & > img {
      width: 70px;
      height: 70px;
      object-fit: cover;
      margin: 0 10px;
    }

    .status {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      flex: 1;
      height: 100%;
      padding-left: 20px;
      font-size: 14px;


      p {
        margin: 0;

        &:nth-of-type(1) {
          margin-bottom: 6px;
        }
      }
    }
  }

  .bill {
    position: relative;
    padding: 16px;
    color: #323233;
    font-size: 12px;
    background-color: #fafafa;
    margin-top: 10px;

    .bill_info {
      display: flex;
      color: #323233;
      font-size: 12px;
      align-items: center;

      & > img {
        width: 88px;
        height: 88px;
        object-fit: cover;
        margin-right: 20px;
      }

      .bill_text {
        & > div {
          margin: 4px 0;

          &.bold {
            font-weight: bold;
          }
        }
      }
    }

    .people_info {
      margin-top: 20px;

      .line {
        width: 100%;
        height: 2px;
        margin-bottom: 10px;
        background: repeating-linear-gradient(-45deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
        background-size: 80px;
      }
    }
  }
}

</style>
